import { createFileRoute } from '@tanstack/react-router';
import { RequireService } from '@/components/shared/require-service';
import { GroupServicesPage } from '@/features/groups/group-services-page';

export const Route = createFileRoute('/_app/settings/groups/$groupId/services')({
  component: RouteComponent,
});

function RouteComponent() {
  const { groupId } = Route.useParams();
  return (
    <RequireService service="GROUP_SERVICE_MANAGE">
      <GroupServicesPage groupId={groupId} />
    </RequireService>
  );
}
